require('generated/services.min');
require('main');
require('app');
require('ec');
